import { Switch, FormControlLabel } from '@mui/material'
import { useField } from 'formik'
import React from 'react'
import { translate } from 'utils/propKeysTranslations'
import { FieldWithContent } from './FieldWithContent'

export const BooleanField = ({
  fieldName, defaultChecked = false, ...props
}) => {
  const [_field, meta, { setValue }] = useField({ ...props, name: fieldName })

  return (
    <FieldWithContent fieldName={fieldName}>
      <FormControlLabel
        control={(
          <Switch
            checked={meta.value ?? defaultChecked}
            onChange={(e) => setValue(e.target.checked)}
            color='primary'
          />
        )}
        label={translate(fieldName)}
      />
      {meta.touched && meta.error && <div className='text-red-500 text-sm'>{meta.error}</div>}
    </FieldWithContent>
  )
}
